import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../../../../base/i18n.js.jsx";

import Container from "../../../../base/components/container.js";
import HtmlContent from "../../../../base/components/html_content.js";

const blockStyles = makeStyles(theme => ({
  root: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
    "&:after": {
      content: "' '",
      clear: "both",
      display: "table"
    },
    "& p": {
      marginBottom: "50px",
      ['@media (max-width: 768px)']: {
        marginBottom: "30px",
      }
    },
    "& .ck-content .table table": {
      marginTop: "50px",
      marginBottom: "50px",
      ['@media (max-width: 992px)']: {
        marginTop: "0px",
        marginBottom: "40px"
      },
      ['@media (max-width: 768px)']: {
        marginTop: "0px",
        marginBottom: "20px"
      }
    }
  }
}));

const DescriptionBlock =  (props) => {

  const classes = blockStyles();
  const { className, downloadable } = props;
  return (
    <Container className = { clsx(classes.root, className) } >
      <HtmlContent>
        { downloadable.sanitizedContent }
      </HtmlContent>
    </Container>
  );
}

export default DescriptionBlock;
